import { render, staticRenderFns } from "./PleurisyMedicationReportForm.vue?vue&type=template&id=2011e896&scoped=true&"
import script from "./PleurisyMedicationReportForm.vue?vue&type=script&lang=ts&"
export * from "./PleurisyMedicationReportForm.vue?vue&type=script&lang=ts&"
import style0 from "./PleurisyMedicationReportForm.vue?vue&type=style&index=0&id=2011e896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2011e896",
  null
  
)

export default component.exports